import script from "./Plantfx1.vue?vue&type=script&setup=true&lang=js"
export * from "./Plantfx1.vue?vue&type=script&setup=true&lang=js"

import "./Plantfx1.vue?vue&type=style&index=0&id=23d5e300&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d5e300"]])

export default __exports__